// import 'setimmediate';
// import { createLogger, format, transports, addColors } from 'winston';
// const { combine, printf, splat, colorize, cli , simple} = format;

// // const myFormat = printf((info) => {
// //   const { timestamp, level, message, ...rest } = info;

// //   const json = rest && JSON.stringify(rest);
// //   return `${timestamp} ${level}: ${message} ${(json !== '{}' && json) || ''}`;
// // });
 import { dev } from './dev';

// const level = (dev && 'debug') || 'info';
// // console.log('using level', level);

// addColors({
//   warn: 'italic red blueBG',
// });

// export const logger = createLogger({
//   level,

//   format: combine(colorize(), splat(), simple()),
//   // format: combine(colorize(), timestamp(), splat(), simple(), myFormat),
//   transports: new transports.Console(),
// });

// logger.deb

export const logger = {
  // warn: console.warn,
  // debug: console.debug,
  // verbose: console.log,
  // error: console.error,

  // critical: console.error,

  log: (...parameters: Array<any>) => {
    if (dev) {
    console.log(...parameters);
    }
    return;
  },

  warn: (...parameters: Array<any>) => {
    console.warn(...parameters);
    return;
  },
  debug: (...parameters: Array<any>) => {
    if (dev) {
    console.debug(...parameters);
    }
    return;
  },
  verbose: (...parameters: Array<any>) => {
    if (dev) {
    console.info(...parameters);
    }
    return;
  },
  error: (...parameters: Array<any>) => {
    console.error(...parameters);
    return;
  },

  critical: (...parameters: Array<any>) => {
    console.error(...parameters);
    return;
  },
};
